import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=a854d990&scoped=true"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=a854d990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a854d990",
  null
  
)

export default component.exports